import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class PaletaService {

  baserApiUrl:string=environment.baseApi
  constructor(public http:HttpClient) { }

  getPaleta(){
    return this.http.get(`${this.baserApiUrl}paleta`)
  }
}


